export default __webpack_public_path__ + "static/media/linkedinwhite.9dc65c89.svg";